module.exports = __webpack_public_path__ + "img/car-parks.0c27435.jpg";